<form #propertiesForm="ngForm">
  <datalist id="propertyTypes">
    <option *ngFor="let type of propertyTypes">{{type}}</option>
  </datalist>
  <div class="row property-container">
    <div class="primary-panel col-xs-3 tab-content">
      <!----------- UI Properties ----------->
      <div (click)="showAccordions('ui')" class="property-list">
        <div class="panel-heading">
        <h4 class="panel-title">
        <span accordion-heading>
          <button class="wm-icon fa" [ngClass]="{'fa-caret-right': !showUIProps, 'fa-caret-down': showUIProps}"></button> {{locale.LABEL_PREFAB_PROPS_WIDGET_PROPERTIES}}
          <button type="button" class="btn btn-sm app-button button-primary float-right add-property" (click)="addProperty($event)" title="{{locale.TITLE_PREFAB_PROPS_ADD_PROPERTY}}">{{locale.LABEL_ADD}}</button>
        </span>
        </h4>
      </div>
        <div *ngIf="showUIProps" class="panel-body">
          <p class="no-prop-message" *ngIf="noPropsAvailable">{{locale.MESSAGE_NO_PROPERTIES_EXIST}}</p>
          <ul class="list-items properties" *ngIf="!noPropsAvailable" id="uiproperties">
            <li class="list-item"
                *ngFor="let property of properties; let index = index;"
                [ngClass]="{'active': (selectedPropertyType === 'widget' && index === selectedPropertyIndex), 'bg-danger': property.invalid}"
                (click)="selectProperty(property, 'widget', index)">
              <div class="item">
                <i class="wms" [ngClass]="{'wms-link': property.bindable}"></i>
                <span class="title" title="{{property.displayName || property.name || property.tempName}}">{{property.displayName || property.name || property.tempName}}</span>
                <i class="sub text-muted">{{property.type}}</i>
                <button type="button" class="btn app-button btn-transparent btn-delete float-right" (click)="removeProperty(property)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_PROPERTY}}">
                  <i class="wm-icon wms wms-delete"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!----------- Server Properties ----------->
      <div (click)="showAccordions('server')" class="property-list">
        <div class="panel-heading">
          <h4 class="panel-title">
        <span accordion-heading>

        <button class="wm-icon fa" [ngClass]="{'fa-caret-right': !showServerProps, 'fa-caret-down': showServerProps}"></button>
          {{locale.LABEL_PREFAB_PROPS_SERVERPROPERTIES}}
          <button type="button" class="btn btn-sm app-button button-primary float-right add-property" (click)="addServerProperty($event)" title="{{locale.TITLE_PREFAB_PROPS_ADD_PROPERTY}}">{{locale.LABEL_ADD}}</button>
        </span>
        </h4>
        </div>
        <div *ngIf="showServerProps"  class="panel-body">
          <p class="no-prop-message" *ngIf="noServerPropsAvailable">{{locale.MESSAGE_NO_PROPERTIES_EXIST}}</p>
          <ul class="list-items properties" *ngIf="!noServerPropsAvailable" id="serverproperties">
            <li class="list-item"
                *ngFor="let property of serverProperties; let index = index;"
                [ngClass]="{'active': (selectedPropertyType === 'server' && index === selectedPropertyIndex), 'bg-danger': property.invalid}"
                (click)="selectProperty(property, 'server', index)">
              <div class="item">
                <span class="title" title="{{property.key || '[Invalid]'}}">{{property.key || '[Invalid]'}}</span>
                <i class="sub text-muted">{{property.type}}</i>
                <button type="button" class="btn app-button btn-transparent btn-delete float-right" (click)="removeServerProperty(property)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_PROPERTY}}">
                  <i class="wm-icon wms wms-delete"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-9 tab-content">
      <!------------ UI Properties ------------>
      <div *ngIf="selectedPropertyType === 'widget' && enableUIProps" class="secondary-panel properties-tab">
        <h5>{{locale.LABEL_GENERAL}}</h5>
        <div class="form-group app-composite-widget clearfix">
          <label class="app-label col-xs-3 required">{{locale.LABEL_NAME}}</label>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_PROPERTYNAME}}" class="wm-icon wms wms-help help-text-icon"></i>
          <i *ngIf="propertyName.touched && (selectedProperty.nameInvalid || propertyName.invalid)" class="wms wms-error-outline" title="{{nameErrMsg || locale.MESSAGE_PREFAB_ERROR_PATTERN_PROPERTY_NAME}}"></i>
          <input class="form-control col-xs-6"
                 [(ngModel)]="selectedProperty.name"
                 [ngClass]="{'error ng-invalid': selectedProperty.invalid}"
                 pattern="^[a-z0-9]*$"
                 name="propertyName"
                 #propertyName="ngModel"
                 placeholder="{{locale.MESSAGE_PREFAB_ERROR_PATTERN_PROPERTY_NAME}}"
                 (change)="validateFields('name')"
                 title="{{locale.MESSAGE_PREFAB_ERROR_PATTERN_PROPERTY_NAME}}"
                 [ngModelOptions]="{updateOn: 'change'}"
                 required>
        </div>

        <div class="form-group app-composite-widget clearfix">
          <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_DISPLAYNAME}}</label>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DISPLAYNAME}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          <input class="form-control col-xs-6" name="display-name" [(ngModel)]="selectedProperty.displayName" title="{{selectedProperty.displayName}}" [ngModelOptions]="{updateOn: 'change'}">
        </div>

        <div class="form-group app-composite-widget clearfix">
          <label class="app-label col-xs-3 required">{{locale.LABEL_PREFAB_PROPS_HELP}}</label>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_HELPTEXT}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          <i *ngIf="selectedProperty.descriptionInvalid" class="wms wms-error-outline" title="{{locale.MESSGAE_FILL_OUT_FIELD}}"></i>
          <textarea class="form-control col-xs-6 app-textarea pty-textarea" name="description"
                    [(ngModel)]="selectedProperty.description" [ngModelOptions]="{updateOn: 'change'}"
                    (change)="validateFields('description')" rows="5" required></textarea>
        </div>
        <hr>

        <h5>{{locale.LABEL_DATA}}</h5>
        <div class="form-group app-composite-widget clearfix">
          <label class="app-label col-xs-3 required">{{locale.LABEL_PREFAB_PROPS_TYPE}}</label>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DATATYPE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          <i *ngIf="selectedProperty.typeInvalid" class="wms wms-error-outline" title="{{locale.MESSGAE_FILL_OUT_FIELD}}"></i>
          <input class="form-control col-xs-6"
                 name="data-type" [(ngModel)]="selectedProperty.type" [ngModelOptions]="{updateOn: 'change'}"
                 (change)="validateFields('type')"
                 required list="propertyTypes">
        </div>

        <div class="form-group app-composite-widget clearfix">
          <label class="app-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_ISLIST}}</label>
          <wms-toggle [hideLabels]="true" id="isList" [model]="selectedProperty.isList" (onChange)="onToggleChange('isList', $event)" name="isList"></wms-toggle>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_ISLISTTYPE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
        </div>

        <div class="form-group app-composite-widget clearfix"
             [ngSwitch]="isBindExpression(selectedProperty.value) ? '' : selectedProperty.type"
             [ngClass]="{'disable-input' : isBindExpression(selectedProperty.value)}">

          <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_VALUE}}</label>

          <div *ngSwitchDefault>
            <input class="form-control col-xs-6"
                   wmsExpressionError [expression]="selectedProperty.value"
                   name="default-value" [(ngModel)]="selectedProperty.value"
                   title="{{selectedProperty.value}}"
                   (click)="showVariableDialog(selectedProperty.value)"
                   [readOnly]="isBindExpression(selectedProperty.value)"
                   [ngModelOptions]="{updateOn: 'blur'}">
          </div>
          <wms-toggle [hideLabels]="true" id="value" [model]="selectedProperty.value" (onChange)="onToggleChange('value', $event)" name="value" *ngSwitchCase="'boolean'"></wms-toggle>
          <input class="form-control col-xs-6"
                 name="default-value-date" [(ngModel)]="selectedProperty.value"
                 type="date"
                 *ngSwitchCase="'date'"
                 [ngModelOptions]="{updateOn: 'change'}">
          <input class="form-control col-xs-6"
                 name="default-value-number" [(ngModel)]="selectedProperty.value"
                 title="{{selectedProperty.value}}"
                 type="number"
                 *ngSwitchCase="'number'"
                 [ngModelOptions]="{updateOn: 'change'}">

          <i title="{{locale.LABEL_CLEAR_BINDING}}"
             class="wms wms-clear clear-icon"
             *ngIf="isBindExpression(selectedProperty.value)"
             (click)="clearBoundValue($event, selectedProperty, 'value', '')"></i>

          <button type="button"
                  class="wms wms-link"
                  (click)="handlePropertyBinding(selectedProperty, 'value')"
                  title="{{locale.LABEL_BIND_VARIABLE}}"></button>

          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DEFAULTVALUE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
        </div>

        <div class="form-group app-composite-widget clearfix">
          <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_BINDABLE}}</label>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_BINDINGTYPE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          <select class="col-xs-6 app-select form-control"
                  name="binding-type" [(ngModel)]="selectedProperty.bindable"
                  (change)="onBindableValChange()">
            <option *ngFor="let bindingType of bindingTypes" [ngValue]="bindingType">{{bindingType}}</option>
          </select>
        </div>
         <hr>
        <div *ngIf="selectedProperty.bindable !== 'out-bound'">
          <h5>{{locale.LABEL_PREFAB_GROUP_WIDGET}}</h5>
          <div class="form-group app-composite-widget clearfix">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_WIDGET}}</label>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_WIDGETTYPE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
            <select class="col-xs-6 app-select form-control"
                    name="widget-type" [(ngModel)]="selectedProperty.widget"
                    (change)="onChangeWidgetType(selectedProperty)">
              <option *ngFor="let widgetType of widgetTypes" [ngValue]="widgetType.key">{{widgetType.value}}</option>
            </select>
          </div>

          <div class="form-group app-composite-widget clearfix" *ngIf="selectedProperty.widget==='slider'">
            <label class="control-label col-xs-3">{{locale.LABEL_PROPERTY_MINVALUE}}</label>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MINVALUE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
            <input type="number"
                   class="form-control col-xs-6"
                   title="{{selectedProperty.sliderMin}}"
                   max="{{selectedProperty.sliderMax}}"
                   name="slider-min" [(ngModel)]="selectedProperty.sliderMin" [ngModelOptions]="{updateOn: 'change'}">
          </div>

          <div class="form-group app-composite-widget clearfix" *ngIf="selectedProperty.widget==='slider'">
            <label class="control-label col-xs-3">{{locale.LABEL_PROPERTY_MAXVALUE}}</label>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MAXVALUE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
            <input type="number"
                   class="form-control col-xs-6"
                   title="{{selectedProperty.sliderMax}}"
                   min="{{selectedProperty.sliderMin}}"
                   name="slider-max" [(ngModel)]="selectedProperty.sliderMax" [ngModelOptions]="{updateOn: 'change'}">
          </div>

          <div class="form-group app-composite-widget clearfix" *ngIf="selectedProperty.widget==='slider'">
            <label class="control-label col-xs-3">{{locale.LABEL_PROPERTY_STEP}}</label>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PROPERTY_STEP}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
            <input type="number"
                   class="form-control col-xs-6"
                   title="{{selectedProperty.sliderStep}}"
                   max="{{selectedProperty.sliderMax}}"
                   name="slider-step" [(ngModel)]="selectedProperty.sliderStep" [ngModelOptions]="{updateOn: 'change'}">
          </div>

          <div class="form-group app-composite-widget clearfix" *ngIf="enableOptions(selectedProperty)">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_OPTIONS}}</label>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DATAOPTIONS}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
            <select class="col-xs-6 app-select form-control"
                    name="depends-on" [(ngModel)]="selectedProperty.dependsOn"
                    (change)="selectedProperty.options = '';">
              <option *ngFor="let dependsOnType of dependsOnTypes" [ngValue]="dependsOnType.key">{{dependsOnType.value}}</option>
            </select>
          </div>

          <div class="form-group app-composite-widget clearfix"
               *ngIf="selectedProperty.dependsOn === 'custom' && enableOptions(selectedProperty);"
               [ngClass]="{'disable-input' : isBindExpression(selectedProperty.options)}">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_DATASET}}</label>
            <input class="form-control col-xs-6"
                   title="{{selectedProperty.options}}"
                   name="data-set" [(ngModel)]="selectedProperty.options"
                   (click)="showVariableDialog(selectedProperty.options)"
                   [readOnly]="isBindExpression(selectedProperty.options)"
                   [ngModelOptions]="{updateOn: 'change'}">
            <i title="{{locale['LABEL_CLEAR_BINDING']}}" class="wms wms-clear clear-icon"
               *ngIf="isBindExpression(selectedProperty.options)" (click)="clearBoundValue($event, selectedProperty, 'options', '')"></i>
            <button type="button" class="wms wms-link" (click)="handlePropertyBinding(selectedProperty, 'options')" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DATASET}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          </div>

          <div class="form-group app-composite-widget clearfix" *ngIf="selectedProperty.dependsOn === 'property' && enableOptions(selectedProperty);"
               [ngClass]="{'disable-input' : isBindExpression(selectedProperty.options)}">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_PROPERTYNAME}}</label>
            <select class="col-xs-6 app-select form-control"
                    name="property-name" [(ngModel)]="selectedProperty.options" [ngModelOptions]="{updateOn: 'change'}">
              <option *ngFor="let property of excludeSelectedProperty()" [ngValue]="property.name">{{property.name}}</option>
            </select>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_DATAOPT_DEPENDSON_PROPERTYNAME}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          </div>

          <div class="form-group app-composite-widget clearfix" [ngSwitch]="isBindExpression(selectedProperty.show) ? 'input' : ''"
               [ngClass]="{'disable-input' : isBindExpression(selectedProperty.show)}">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_SHOW}}</label>
            <wms-toggle [hideLabels]="true" id="show" [model]="selectedProperty.show" (onChange)="onToggleChange('show', $event)" name="show" *ngSwitchDefault></wms-toggle>
            <input class="form-control col-xs-6"
                   name="property-show" [(ngModel)]="selectedProperty.show"
                   title="{{selectedProperty.show}}"
                   *ngSwitchCase="'input'"
                   (click)="showVariableDialog(selectedProperty.show)"
                   [readOnly]="isBindExpression(selectedProperty.show)"
                   [ngModelOptions]="{updateOn: 'change'}">
            <i title="{{locale['LABEL_CLEAR_BINDING']}}" class="wms wms-clear clear-icon" *ngIf="isBindExpression(selectedProperty.show)" (click)="clearBoundValue($event, selectedProperty, 'show', true)"></i>
            <button name="wm-bind-property-show" type="button" class="wms wms-link" (click)="handlePropertyBinding(selectedProperty, 'show')" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_SHOW}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          </div>

          <div class="form-group app-composite-widget clearfix">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_SHOW_AT}}</label>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_SHOW_AT}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
            <select class="col-xs-6 app-select form-control"
                    name="show-at" [(ngModel)]="selectedProperty.showAt"
                    [ngModelOptions]="{updateOn: 'change'}">
              <option *ngFor="let widget of selectableWidgets" [ngValue]="widget.pageName + '.' + widget.pageWidget">{{widget.pageWidget}}</option>
            </select>
          </div>

          <div class="form-group app-composite-widget clearfix" [ngSwitch]="isBindExpression(selectedProperty.disabled) ? 'input' : ''"
               [ngClass]="{'disable-input' : isBindExpression(selectedProperty.disabled)}">
            <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_DISABLED}}</label>
            <wms-toggle [hideLabels]="true" id="disabled" [model]="selectedProperty.disabled" (onChange)="onToggleChange('disabled', $event)" name="disabled" *ngSwitchDefault></wms-toggle>
            <input class="form-control col-xs-6"
                   title="{{selectedProperty.disabled}}"
                   name="disabled" [(ngModel)]="selectedProperty.disabled"
                   *ngSwitchCase="'input'"
                   (click)="showVariableDialog(selectedProperty.disabled)"
                   [readOnly]="isBindExpression(selectedProperty.disabled)"
                   [ngModelOptions]="{updateOn: 'change'}">
            <i title="{{locale.LABEL_CLEAR_BINDING}}" class="wms wms-clear clear-icon" *ngIf="isBindExpression(selectedProperty.disabled)" (click)="clearBoundValue($event, selectedProperty, 'disabled', false)"></i>
            <button name="wm-bind-property-disabled" type="button" class="wms wms-link" (click)="handlePropertyBinding(selectedProperty, 'disabled')" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DISABLED}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          </div>
        </div>
      </div>

      <!------------ Server Properties ------------>
      <div *ngIf="selectedPropertyType === 'server' && enableServerProps" class="properties-tab">
        <h5>{{locale.LABEL_GENERAL}}</h5>
        <div class="form-group app-composite-widget clearfix">
          <label class="app-label col-xs-3 required">{{locale.LABEL_NAME}}</label>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_PROPERTYNAME}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          <i *ngIf="selectedProperty.invalid" class="wms wms-error-outline" title="{{locale.MESSAGE_PREFAB_ERROR_PATTERN_SERVER_PROPERTY_NAME}}"></i>
          <input class="col-xs-6 form-control pty-name-field"
                 name="property-key" [(ngModel)]="selectedProperty.key"
                 [ngClass]="{'ng-invalid': selectedProperty.invalid}"
                 pattern="^[a-zA-Z0-9]*$"
                 (change)="validateFields('serverproperty')"
                 title="{{locale.MESSAGE_PREFAB_ERROR_PATTERN_SERVER_PROPERTY_NAME}}"
                 [ngModelOptions]="{updateOn: 'change'}"
                 required maxlength="32">
        </div>

        <div class="form-group app-composite-widget clearfix">
          <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_PROPS_VALUE}}</label>
          <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_PROPS_DEFAULTVALUE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
          <input class="col-xs-6 form-control"
                 name="property-value" [(ngModel)]="selectedProperty.defaultValue"
                 title="{{selectedProperty.value}}"
                 [disabled]="selectedProperty.icon === 'clear'"
                 [ngModelOptions]="{updateOn: 'change'}">
        </div>
      </div>
    </div>
  </div>
</form>

<wms-dialog id="BindVariable" [content]="bindVariableDialog" customClasses="bind-variable-dialog wm-studio-dialog large wm-right-panel-container">
</wms-dialog>
<ng-template #bindVariableDialog>
  <wms-bind-dialog-ui (onModalClose)="closeDialogWithId('BindVariable')"></wms-bind-dialog-ui>
</ng-template>

<wms-dialog id="variableModal" [content]="variableContent"
            customClasses="modal large wm-studio-dialog fade add-new-variable-container-dialog wm-right-panel-container" [closeOnEscape]="false">
</wms-dialog>
<ng-template #variableContent>
  <wms-variable-config [variableView]="'Variables'"
                       (onModalClose)="closeDialogWithId('variableModal')"></wms-variable-config>
</ng-template>


